import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import moment from 'moment'
import { makeStyles } from '@mui/styles'
import { DateInput } from '@/modules/base/components/inputs'
import lang from '@/lang'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  input: {
    '& input': {
      height: 39,
      backgroundColor: theme.white,
    },
    '& .SVGInline': {
      display: 'none',
    },
  },
}))

interface ListDateInputProps {
  onDateChanged: () => void
}

export interface ListDateInputHandle {
  getDate: () => Date | null
  setDate: (date: Date | null) => void
}

const ListDateInput = forwardRef<ListDateInputHandle, ListDateInputProps>(({ onDateChanged }, ref) => {
  const classes = useStyles()
  const [date, setDateState] = useState<Date | null>(null)
  // ag-grid resets the filter and reads it back in the same tick, before React re-renders,
  // so getDate() must read from a ref and not from state.
  const currentDate = useRef<Date | null>(null)

  const setDate = (newDate: Date | null) => {
    currentDate.current = newDate
    setDateState(newDate)
  }

  useImperativeHandle(ref, () => ({
    getDate: () => currentDate.current,
    setDate,
  }))

  const handleDateChanged = (value: string | Date | null) => {
    setDate(value ? moment(value).toDate() : null)
    onDateChanged()
  }

  return (
    <div className='ag-input-wrapper'>
      <DateInput
        name='date'
        dataQsId='list-filter-date-input'
        value={date}
        placeholder={lang.customListFilter.chooseDate}
        onChange={handleDateChanged}
        onBlur={handleDateChanged}
        customClass={classes.input}
      />
    </div>
  )
})

export default ListDateInput
